"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceSize = exports.Device = void 0;
var Breakpoints_1 = require("./Breakpoints");
Object.defineProperty(exports, "Device", { enumerable: true, get: function () { return __importDefault(Breakpoints_1).default; } });
Object.defineProperty(exports, "DeviceSize", { enumerable: true, get: function () { return Breakpoints_1.size; } });
//# sourceMappingURL=index.js.map